import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-20de309b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "LogicalTransformerSectorRenderContainer"
};
const _hoisted_2 = {
  class: "flex justify-center pb-4"
};
const _hoisted_3 = {
  class: "text-2xl"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图例提供了具有四个扇形颜色的原始图案， 点击小人后， 其手臂将开始依次指向相应的变换规则，选择经过变换后图案正确的颜色分布。", -1));
const _hoisted_5 = {
  class: "flex items-center py-4 gap-10 justify-center"
};
const _hoisted_6 = {
  key: 2,
  style: {
    "width": "200px"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex justify-center p-2"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text-2xl"
}, "请选择答案")], -1));
const _hoisted_8 = {
  class: "pb-2 px-6"
};
const _hoisted_9 = {
  key: 2,
  class: "flex flex-wrap items-center"
};
const _hoisted_10 = {
  class: "p-4"
};
const _hoisted_11 = {
  class: "px-4"
};
const _hoisted_12 = {
  class: "p-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LogicalTransformerSectorImg = _resolveComponent("LogicalTransformerSectorImg");
  const _component_LogicalTransformerSectorAnimate = _resolveComponent("LogicalTransformerSectorAnimate");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString($props.question.questionIndex + 1) + "题", 1)]), _hoisted_4, _createElementVNode("div", _hoisted_5, [$data.showQuestion ? (_openBlock(), _createBlock(_component_LogicalTransformerSectorImg, {
    key: 0,
    arcs: $props.question.question.flat()
  }, null, 8, ["arcs"])) : _createCommentVNode("", true), ($props.plus ? !$data.showQuestion : true) ? (_openBlock(), _createBlock(_component_LogicalTransformerSectorAnimate, {
    key: 1,
    animates: $props.question.operates
  }, null, 8, ["animates"])) : _createCommentVNode("", true), $props.plus && $data.showQuestion ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", null, "题目将在" + _toDisplayString($data.countDown) + "s后消失", 1)])) : _createCommentVNode("", true)]), _hoisted_7, ($props.plus ? !$data.showQuestion : true) ? (_openBlock(), _createBlock(_component_AnswerButtonGroup, {
    key: 0,
    options: $data.OPTIONS,
    review: $props.review,
    reviewMode: $props.reviewMode,
    onChoose: $options.onChoosed,
    ref: "LogicalTransformerSectorRenderAnswer"
  }, {
    default: _withCtx(btnIndex => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_LogicalTransformerSectorImg, {
      arcs: $props.question.options[btnIndex.index].flat()
    }, null, 8, ["arcs"])])]),
    _: 1
  }, 8, ["options", "review", "reviewMode", "onChoose"])) : _createCommentVNode("", true), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "colFlex bothCenter mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.question.rightAnswer), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      style: _normalizeStyle({
        color: $props.review.result ? 'green' : 'red'
      })
    }, "您的答案：" + _toDisplayString($props.review.answer), 5)) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true), $props.reviewMode ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_LogicalTransformerSectorImg, {
    arcs: $props.question.question.flat()
  }, null, 8, ["arcs"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.question.steps, (s, si) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: `step_${si}`
    }, [_createElementVNode("span", _hoisted_11, "-> " + _toDisplayString($data.transformers[$props.question.operates[si]]) + " ->", 1), _createElementVNode("div", _hoisted_12, [_createVNode(_component_LogicalTransformerSectorImg, {
      arcs: s.flat()
    }, null, 8, ["arcs"])])], 64);
  }), 128))])) : _createCommentVNode("", true)]);
}